import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import admin_avatar_header from "../../../assets/images/avatar.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAdmins } from "../../../Redux/Actions/admin/adminPanel";
import { Link } from "react-router-dom";
import CreateAdminModal from "./CreateAdminModal";
import DeleteAdminModal from "./DeleteAdminModal";
import ReactPaginate from "react-paginate";
import { startstopLoading } from "../../../Redux/Reducers/globalSlice";
import moment from "moment";
const ManageAdmins = () => {
  const admins = useSelector((state) => state.adminPanel.admins);
  const dispatch = useDispatch();
  const [modalShow, setModalShow] = useState(false);
  const [delAdminShow, setDelAdminShow] = useState(false);
  const [adminId, setAdminId] = useState();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(10);
  const [pageCount, setPageCount] = useState();
  const [resultOffset, setResultOffset] = useState(0);
  const [searchedMembers, setSearchedMembers] = useState("");
  const handleAdminDelete = (adminId) => {
    setAdminId(adminId);
    setDelAdminShow(true);
  };

  useEffect(() => {
    dispatch(startstopLoading(true));
    dispatch(getAdmins()).then((res) => {
      if (res?.payload?.success == true || res?.payload?.success == false) {
        dispatch(startstopLoading(false));
      }
    });
  }, []);

  useEffect(() => {
    if (page && searchedMembers) {
      setPageCount(Math.ceil(searchedMembers.length / page));
    }
  }, [searchedMembers, page]);

  useEffect(() => {
    if (admins) {
      setSearchedMembers(admins);
    }
  }, [admins]);

  useEffect(() => {
    const newArr = admins?.filter((data) =>
      data.firstName.toLowerCase().includes(search)
    );
    setSearchedMembers(newArr);
  }, [search]);

  const handlePageClick = (event) => {
    setResultOffset((event.selected * page) % searchedMembers.length);
  };

  return (
    <Layout>
      <div id="layout-wrapper" className="bg-dash admin-table">
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <div>
                      <span className="small_text">Manage Admins</span>
                      <h4 className="mb-sm-0 font-size-28">
                        Admins
                        <span className="header-title-text">
                          {admins?.length}
                        </span>
                      </h4>
                    </div>
                    <div className="page-title-right">
                      <form className="app-search d-none d-lg-block ">
                        <div className="d-flex justify-content-between align-items-center">
                          <div className="position-relative w-100">
                            <input
                              value={search}
                              onChange={(e) => {
                                setSearch(e.target.value), setResultOffset(0);
                              }}
                              type="text"
                              className="form-control"
                              placeholder="Search"
                            />
                            <span className="bx bx-search"></span>
                          </div>
                          {/* <img
                            src={admin_avatar_header}
                            className="avata_serch"
                            alt=""
                          /> */}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              <CreateAdminModal
                show={modalShow}
                onHide={() => setModalShow(false)}
              />
              {adminId && (
                <DeleteAdminModal
                  show={delAdminShow}
                  onHide={() => setDelAdminShow(false)}
                  adminId={adminId}
                />
              )}
              <div className="row">
                <div className="col-xl-12">
                  <div className="members_tbl">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 position-relative">
                          <h4 className="title_text">Admins</h4>
                          <span>
                            <Link>
                              <button
                                type="button"
                                onClick={() => setModalShow(true)}
                                className="btn cre_new"
                              >
                                Create
                              </button>
                            </Link>
                          </span>
                        </div>
                        <div className="table-responsive table-defaut-design dealer-table-c">
                          <table
                            id="datatable"
                            className="table  vehicles_table  w-100"
                          >
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Name</th>
                                <th>Created</th>
                                <th>Email</th>
                                <th>Actions</th>
                              </tr>
                            </thead>
                            <tbody className="td_color trans_table_fix_height">
                              {searchedMembers ? (
                                searchedMembers
                                  ?.slice(resultOffset, resultOffset + page)
                                  ?.map((admin, i) => {
                                    return (
                                      <tr key={admin?._id}>
                                        <td>{i + 1}</td>
                                        <td>
                                          {admin?.firstName
                                            ? admin.firstName
                                                .charAt(0)
                                                .toUpperCase() +
                                              admin.firstName.slice(1)
                                            : ""}
                                          {admin?.firstName && admin?.lastName
                                            ? " "
                                            : ""}
                                          {admin?.lastName
                                            ? admin.lastName
                                                .charAt(0)
                                                .toUpperCase() +
                                              admin.lastName.slice(1)
                                            : ""}
                                        </td>

                                        <td>
                                          {moment(admin?.createdAt).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </td>
                                        <td>{admin?.email}</td>
                                        <td>
                                          <button
                                            type="button"
                                            onClick={() =>
                                              handleAdminDelete(admin?._id)
                                            }
                                            className="deleteBtn "
                                          >
                                            <i class="bx bx-trash"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })
                              ) : (
                                <tr>
                                  <td
                                    colSpan={5}
                                    valign="middle"
                                    className="h-370"
                                  >
                                    <p className="no_content_table">
                                      No Admins yet
                                    </p>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    {searchedMembers.length > 10 && (
                    <div className="d-flex justify-content-center pagination_inner mt-1">
                      <ReactPaginate
                        className="pagination"
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={5}
                        pageCount={pageCount}
                        previousLabel="<"
                        renderOnZeroPageCount={null}
                      />
                    </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default ManageAdmins;
